<template>
  <section id="CartEmpty">
    <h4 class="Cart__Title h4">{{ store.terms.empty.title }}</h4>
    <a class="button button--tertiary-a Cart__EmptyBtn" :href="store.terms.empty.cta_url" data-ht-element="empty-cart-cta-homepage">
      {{ store.terms.empty.cta_text }}
    </a>
    <a class="button button--tertiary-a Cart__EmptyBtn" :href="store.terms.empty.alt_cta_url" data-ht-element="empty-cart-cta-quiz">
      {{ store.terms.empty.alt_cta_text }}
    </a>
  </section>
</template>

<script setup>
import { useCartStore } from './Composables/Store';
import Cookies from 'js-cookie';

const store = useCartStore();

Cookies.remove('_bl_hide_broken_cart_popup', false);
</script>
